// 스크린챗 통행증 API 클라이언트 — /api/v2/me/screenchat-pass
//
// 화면 안 스크린챗 패널(@screenchat/embed)을 «이 사람에게» 띄울지 정한다. 서버가 스크린챗 «서비스 계정으로 들어오기» 명단을
// 확인해 2분짜리 통행증을 주고, 명단 밖이면 null 이다. 통행증은 조회 캐시 저장 목록(lib/persistCache PERSIST_DOMAINS) 밖이라
// 브라우저 저장소에 남지 않는다. 진본 docs/ops/screenchat-embed.md

import { z } from "zod";
import { authJson } from "./_client";

const API = `${import.meta.env.VITE_API_BASE_URL ?? ""}/api/v2/me`;

const passResponse = z.object({ pass: z.string().min(1).nullable() });

export const screenchatKeys = {
  all: ["screenchat"] as const,
  pass: (userId: string) => [...screenchatKeys.all, "pass", userId] as const,
};

/** 로그인한 사람의 통행증 — 명단 밖·열쇠 없음·스크린챗 불통이면 null. */
export async function fetchScreenchatPass(): Promise<string | null> {
  const parsed = passResponse.safeParse(await authJson<unknown>(`${API}/screenchat-pass`));
  return parsed.success ? parsed.data.pass : null;
}
